<script setup>
const props = defineProps({
  data: Object
})
const data = props.data && props.data.contentForUser ? props.data.contentForUser : props.data.content;
const brochureRequestStore = useBrochureRequest();

onMounted(() => {
  if (brochureRequestStore.isOptedOutEmail) {
    document.getElementById('is-existing-user-component').classList.add('opted-out');
  }
});

</script>
<template>
  <div class="is-existing-user block" id="is-existing-user-component">
    <div class="container" v-if="brochureRequestStore.isUser && brochureRequestStore.isOptedOutEmail">
      <div class="row">
        <div class="col">
          <article v-html="data"></article>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
// Temporary styles to hide this component when the user is not opted out and reached a Thank You page or any other page where this component should not be displayed, because now we are displaying only the case when the user is opted out, when the rest of the cases are covered in the future we can remove this
.section-component:has(.is-existing-user:not(.opted-out)) {
  display: none;
}

.is-existing-user {
  img {
    max-width: 100%;
    height: auto !important;
    width: auto !important;
  }
  .btn:not(.btn-link, .btn-text) {
    margin: 10px;
  }
}
</style>